export const EDOCS_RESET_STATE = 'EDOCS_RESET_STATE';
export const EDOCS_CURRENT_ITEM = 'EDOCS_CURRENT_ITEM';

export const EDOCS_REQUEST_LOADING = 'EDOCS_REQUEST_LOADING';
export const EDOCS_REQUEST_SUCCESS = 'EDOCS_REQUEST_SUCCESS';
export const EDOCS_REQUEST_FAILED = 'EDOCS_REQUEST_FAILED';

export const EDOCS_CURRENT_ACTION = 'EDOCS_CURRENT_ACTION';
export const EDOCS_RESET_ACTION = 'EDOCS_RESET_ACTION';